import { useEffect } from "react";
import { connect } from "react-redux";
import AnonymousPage from "../anonymous-pages/anonymous-page";
import BoxWraper from "../box-wrapper";
import {
    resumeSubscription,
    getFullToken,
    resetFetchedFullToken,
    fetchPausedSubscription
} from "./ducks/actions";
import ResumeSubscription from "./resume-subscription";
import { Redirect } from "react-router-dom";

function Payment(props) {
    const {
        resumeSubscription,
        getFullToken,
        resuming,
        resumeComplete,
        errors,
        fetchedFullToken,
        resetFetchedFullToken,
        fetchPausedSubscription,
        loading,
        subscription,
        requiresPaymentMethodUpdate,
        message,
        stripeBillingPortalUrl
    } = props;

    useEffect(() => {
        fetchPausedSubscription();
    }, []);

    useEffect(() => {
        if (resumeComplete) {
            getFullToken();
        }
    }, [resumeComplete]);

    useEffect(() => {
        if (subscription?.isPaid) {
            getFullToken();
        }
    }, [subscription]);

    if (fetchedFullToken) {
        resetFetchedFullToken();
        return <Redirect to="/films" />;
    }

    return (
        <AnonymousPage>
            <BoxWraper width={5}>
                <ResumeSubscription
                    errors={errors}
                    resuming={resuming}
                    resumeComplete={resumeComplete}
                    onResumeSubscription={resumeSubscription}
                    loading={loading}
                    subscription={subscription}
                    requiresPaymentMethodUpdate={requiresPaymentMethodUpdate}
                    message={message}
                    stripeBillingPortalUrl={stripeBillingPortalUrl}
                />
            </BoxWraper>
        </AnonymousPage>
    );
}

function mapStateToProps(state) {
    const { accountState } = state;
    const { resumeSubscriptionState } = accountState;
    return {
        errors: resumeSubscriptionState.errors,
        resuming: resumeSubscriptionState.resuming,
        resumeComplete: resumeSubscriptionState.resumeComplete,
        fetchedFullToken: resumeSubscriptionState.fetchedFullToken,
        subscription: resumeSubscriptionState.subscription,
        loading: resumeSubscriptionState.loading,
        requiresPaymentMethodUpdate: resumeSubscriptionState.requiresPaymentMethodUpdate,
        message: resumeSubscriptionState.message,
        stripeBillingPortalUrl: resumeSubscriptionState.stripeBillingPortalUrl
    };
}

export default connect(mapStateToProps, {
    resumeSubscription,
    getFullToken,
    resetFetchedFullToken,
    fetchPausedSubscription
})(Payment);
